import { useEffect, useRef } from 'react';

function useClickOutside(handler) {
  const domNode = useRef();

  useEffect(() => {
    let maybeHandler = event => {
      if (!domNode.current?.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', maybeHandler);

    return () => {
      document.removeEventListener('mousedown', maybeHandler);
    };
  }, [handler]); // Re-run if handler changes

  return domNode;
}

export default useClickOutside;
